import React from 'react';
import style from './formEditor.scss'
import {defaultFieldAttrs} from "../schema"
import style2 from '../backend.scss'
import TabContents from "./Tabcontents";
import {tabLabels, checkIsReadOnly} from "../schema"


const tabs = {
    general: {'label': "General"},
    advanced: {'label': "Advanced"},
    conditional: {'label': "Conditional"},
};


const Tabs = (props) => {
    return (<ul>
        {Object.keys(tabs).map(key => {
            return <li onClick={() => {
                return props.switchTab(key)
            }}>{tabs[key].label}</li>
        })}
    </ul>)
}


class FormEditor extends React.Component {





    handleChange = (field, index) => {

        // const updatedFields = {[this.props.section]: {...update(this.props.field, {field: {$set: field}})}}
        // this.props.dispatch(insertField(updatedFields))
        this.props.handleChange(field, index);//

    }


    constructor(props) {
        super(props);

    }

    closePopup = (e) => {
        this.props.closePopup(e)
    }

    switchTab = tab => {
       this.props.switchTab(tab);
    }

    render() {
        const {field, index,openTabs} = this.props;

        return (
            <div
                className={style.editor}
            >
                <TabContents
                    schema={defaultFieldAttrs(field.type)}
                    switchTab={this.switchTab}
                    field={field}
                    openTabs={openTabs}
                    tabLabels={tabLabels}
                    checkIsReadOnly={checkIsReadOnly}
                    handleChange={(f) => {
                        return this.handleChange(f, index)
                    }}
                />

            </div>


        )
    }


}

export default FormEditor;
